module.exports = __webpack_public_path__ + "img/camera.7d87e454.svg";